import { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';
import { ADigitProps } from '../../atoms/ADigit/ADigit.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { MButtonProps } from '../MButton/MButton.types';

export enum MHighlightNumericAlignment {
  Centered = 'Centered',
  Left = 'Left',
}

export interface MHighlightNumericProps {
  alignment?: MHighlightNumericAlignment;
  showCTA?: boolean;
  aAccentLine?: AAccentLineProps;
  aDigit: ADigitProps;
  aBody?: ABodyProps;
  mButton?: MButtonProps<React.ElementType<HTMLButtonElement | HTMLAnchorElement>>;
  hasAccentLine?: boolean;
}
